export type ProgressBarProps = {
	/**
	 * Value of the progress bar.
	 */
	value?: number;

	/**
	 * A CSS class to apply to the progress bar wrapper (track) element.
	 */
	className?: string;
};
